module.exports = __webpack_public_path__ + "static/map-cc7368e023c54472d00c31fa5a7d68f5.svg";